import React, {Suspense, lazy} from "react";
import {Redirect, Switch, Route} from "react-router-dom";
import {LayoutSplashScreen, ContentRoute} from "../_metronic/layout";
// import { MetricsPage } from "./modules/Metrics/pages/metrics/MetricsPage";
const ECommercePage = lazy(() =>
  import("./modules/CRM/pages/eCommercePage")
);
const TripTrackingPage = lazy(() =>
  import("./modules/TripTracking/pages/tripTrackingPage")
);
const ReportsHome = lazy(() =>
  import("./modules/Reports/pages/ReportsHome")
);
const TelemetryHome = lazy(() =>
  import("./modules/GPS/pages/gpsHome")
);
const MetricsPage = lazy(() =>
  import("./modules/Metrics/pages/metricsHome")
);

export default function BasePage() {
    // useEffect(() => {
    //   console.log('Base page');
    // }, []) // [] - is required if you need only one call
    // https://reactjs.org/docs/hooks-reference.html#useeffect

    return (
        <Suspense fallback={<LayoutSplashScreen/>}>
            <Switch>
                {
                    <Redirect exact from="/" to="/trip-tracking"/>
                }
                <ContentRoute path="/metrics" component={MetricsPage}/>
                <Route path="/master" component={ECommercePage}/>
                <Route path="/trip-tracking" component={TripTrackingPage}/>
                <Route path="/reports" component={ReportsHome}/>
                <Route path="/telemetry" component={TelemetryHome}/>
                <Redirect to="error/error-v1"/>
            </Switch>
        </Suspense>
    );
}
